/**
 * useBranding -- convenience hook to access platform branding.
 *
 * Returns the current branding config with Opus defaults as fallback.
 * Components using this hook will re-render when branding changes.
 *
 * Usage:
 *   const { platform_name, logo_url, primary_color, secondary_color, default_theme } = useBranding();
 */

import { useBrandingStore } from '@/stores/useBrandingStore';
import { BRANDING_DEFAULTS, type BrandingPublicShape } from '@/config/brandingDefaults';

export function useBranding(): BrandingPublicShape & { isLoaded: boolean } {
  const branding = useBrandingStore((s) => s.branding);
  const isLoaded = useBrandingStore((s) => s.isLoaded);

  return {
    platform_name: branding.platform_name || BRANDING_DEFAULTS.platform_name,
    logo_url: branding.logo_url ?? BRANDING_DEFAULTS.logo_url,
    primary_color: branding.primary_color || BRANDING_DEFAULTS.primary_color,
    secondary_color: branding.secondary_color || BRANDING_DEFAULTS.secondary_color,
    default_theme: branding.default_theme || BRANDING_DEFAULTS.default_theme,
    isLoaded,
  };
}
